import type { LocationFormMaxLengths } from "@sal/onevent-portal";

export const LocationMaxLengths: LocationFormMaxLengths = {
	name: 50,
	address1: 30,
	suburb: 30,
	contact: 25,
	email: 100
};
